import React from 'react';

import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import { IconDefinition } from '@fortawesome/fontawesome-common-types';

import { Box } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import { TooltipProps } from '@mui/material/Tooltip/Tooltip';

import { FontAwesomeSvgIcon } from './index';

export interface IconTooltipProps {
  icon?: IconDefinition;
  color?: SvgIconProps['color'];
  title: string;
  placement?: TooltipProps['placement'];
  fontSize?: 'medium' | 'small';
}

export const IconTooltip: React.FC<IconTooltipProps> = ({
  icon = faInfoCircle,
  color = 'info',
  title,
  fontSize = 'medium',
  placement = 'bottom'
}) => (
  <Box padding={1}>
    <Tooltip title={title} placement={placement}>
      <FontAwesomeSvgIcon icon={icon} color={color} fontSize={fontSize} />
    </Tooltip>
  </Box>
);
